import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import ListingDetails from './ListingDetails';


const Container = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  width: 60%;
  max-width: 1200px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

const ImageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 600px;
  margin-bottom: 20px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 45px;
`;

const MainImageContainer = styled.div`
  width: calc(50% - 10px);
  height: 100%;
  background-color: #eee;
  margin: 0px 10px 0px 0px;
  overflow: hidden;
`;

const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ThumbnailsContainer = styled.div`
  display: grid;
  width: 50%;
  height: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
`;

const ThumbnailWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const ListingDetail = ({ isAuthenticated }) => {
  const { id } = useParams();
  const [listing, setListing] = useState(null);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/listings/${id}/details`);
        // const response = await fetch(`http://localhost:8000/listings/${id}/details`);
        const data = await response.json();
        setListing(data);
      } catch (error) {
        console.error('Error fetching listing details:', error);
      }
    };

    fetchListing();
  }, [id]);

  if (!listing) {
    return <p>Loading...</p>;
  }

  const imagesArray = listing.images.split(',');

  return (
    <Container>
      <Content>
        <ImageContainer>
          <MainImageContainer>
            <MainImage src={imagesArray[0]} alt="Main office space" />
          </MainImageContainer>
          <ThumbnailsContainer>
            {imagesArray.slice(1, 5).map((image, index) => (
              <ThumbnailWrapper key={index}>
                <Thumbnail src={image} alt={`Thumbnail ${index + 1}`} />
              </ThumbnailWrapper>
            ))}
          </ThumbnailsContainer>
        </ImageContainer>
        <DetailsContainer>
          <ListingDetails listing={listing} isAuthenticated={isAuthenticated}/>
        </DetailsContainer>
      </Content>
    </Container>
  );
};

export default ListingDetail;
